import { gql } from '@apollo/client';
const ADD_MODEL = gql `
  mutation AddModel($folderId: ID) {
    addModelSpecification(folderId: $folderId) {
      modelSpecification {
        id
        archivedAt
        itemCode
        fancyName
        folder {
          id
          name
          modelSpecificationsCount
        }
        season {
          name
        }
        state
        projections {
          edges {
            node {
              picture
            }
          }
        }
        componentsCount
        sizes {
          edges {
            node {
              id
              isActive
              sizeName {
                id
                name
              }
            }
          }
        }
        specificationTeamMembersNode {
          id
          adminName
          patternerName
          designerName
          productionName
        }
      }
    }
  }
`;
export default ADD_MODEL;
